// MyComponent.js
import React from 'react';
import myLogo from '../../aryannlogo.png';
function Footer() {
    return (
        <footer className="bg-gray-100 dark:bg-gray-900">
            <div className="container px-6 py-8 mx-auto">
                <div className="flex flex-col items-center text-center">
                    <a href="#contact">
                        <img className="w-auto h-7" src={myLogo} alt="" />
                    </a>

                    

                </div>

                <hr className="my-6 border-gray-300 dark:border-gray-700 md:my-10" />

                <div className="flex flex-col items-center sm:flex-row sm:justify-between">
                    <p className="text-sm text-gray-600 dark:text-gray-300">© Copyright 2024. All Rights Reserved.</p>

                    <div className="flex -mx-2">
                        <a href="https://github.com/aryanndwi123" className="mx-2 text-gray-700 dark:text-gray-300 transition-colors duration-300 hover:text-blue-500 dark:hover:text-blue-400" aria-label="GitHub" target="_blank" rel="noopener noreferrer">
                            <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.47 2 2 6.47 2 12c0 4.42 2.87 8.17 6.84 9.49.5.09.68-.22.68-.48v-1.7c-2.78.6-3.37-1.34-3.37-1.34-.46-1.17-1.13-1.48-1.13-1.48-.92-.63.07-.62.07-.62 1.02.07 1.56 1.05 1.56 1.05.9 1.54 2.37 1.1 2.95.84.09-.65.35-1.1.63-1.35-2.2-.25-4.52-1.1-4.52-4.9 0-1.08.39-1.96 1.03-2.65-.1-.25-.45-1.26.1-2.63 0 0 .84-.27 2.75 1.02.8-.22 1.65-.33 2.5-.33s1.7.11 2.5.33c1.91-1.29 2.75-1.02 2.75-1.02.56 1.37.21 2.38.1 2.63.64.69 1.03 1.57 1.03 2.65 0 3.81-2.32 4.65-4.54 4.9.36.31.68.92.68 1.86v2.77c0 .26.18.57.69.47C19.14 20.16 22 16.41 22 12c0-5.53-4.47-10-10-10z"/>
                            </svg>
                        </a>
                        
                        <a href="https://x.com/dwivedi_aryann"  className="mx-2 text-gray-700 dark:text-gray-300 transition-colors duration-300 hover:text-blue-500 dark:hover:text-blue-400" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                            <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.46 6c-.84.37-1.75.62-2.7.73.97-.58 1.72-1.5 2.07-2.6-.91.54-1.92.92-3 1.13-.87-.93-2.11-1.5-3.48-1.5-2.64 0-4.78 2.14-4.78 4.78 0 .37.04.73.13 1.08-3.98-.2-7.51-2.11-9.87-5.02-.41.7-.65 1.52-.65 2.39 0 1.65.84 3.1 2.12 3.95-.78-.03-1.51-.24-2.15-.6v.06c0 2.31 1.65 4.23 3.85 4.67-.4.1-.82.16-1.26.16-.3 0-.6-.03-.89-.08.6 1.88 2.33 3.25 4.39 3.28-1.61 1.26-3.65 2.01-5.86 2.01-.38 0-.75-.02-1.12-.07 2.1 1.35 4.6 2.14 7.29 2.14 8.74 0 13.5-7.24 13.5-13.5 0-.2 0-.39-.01-.59.92-.67 1.72-1.51 2.36-2.46z"/>
                            </svg>
                        </a>

                        <a href="https://www.linkedin.com/in/aryann-dwivedi-9a20b4227/" className="mx-2 text-gray-700 dark:text-gray-300 transition-colors duration-300 hover:text-blue-500 dark:hover:text-blue-400" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                            <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 3H4a2 2 0 00-2 2v14c0 1.1.9 2 2 2h16a2 2 0 002-2V5a2 2 0 00-2-2zM8 18H5V10h3v8zM6.5 8.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM19 18h-3v-4.78c0-1.16-.4-1.94-1.4-1.94-.76 0-1.2.52-1.4 1.02-.08.2-.08.48-.08.76V18h-3V10h3v1.06c.5-.8 1.38-1.94 3-1.94 2.2 0 4 1.42 4 4.5V18z"/>
                            </svg>
                        </a>
                    </div>

                </div>
            </div>
        </footer>

        
    );
}

export default Footer;
